import type { InjectionKey } from "vue";
import type { AppConfig } from "../app_config_provider";

const API_PATH = "/v4/product";
const CACHE_TIME_MS = 24 * 60 * 60 * 1000;

export interface ProductDto {
  id: number;
  type: string;
  title: string;
  pos: number;
  is_main: boolean;
}

export class ProductApi {
  private readonly config: Pick<AppConfig, "api_url" | "api_token">;
  private cache: ProductDto[] | null = null;
  private cachedAt: number = 0;

  constructor(config: Pick<AppConfig, "api_url" | "api_token">) {
    this.config = config;
  }

  async getAllCached(
  ): Promise<ProductDto[]> {
    if (this.cache && Date.now() - this.cachedAt < CACHE_TIME_MS) {
      return this.cache;
    }

    this.cache = await this.getAll();
    this.cachedAt = Date.now();

    return this.cache;
  }

  async getAll(
  ): Promise<ProductDto[]> {
    const response = await fetch(`${this.config.api_url}${API_PATH}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-API-TOKEN": this.config.api_token,
      },
    });

    if (!response.ok) {
      console.log(`getAll: ${response.status} ${response.statusText}`);
      throw new Error('General_Api_Failed')
    }

    return response.json() as Promise<ProductDto[]>;
  }
}

export const productApiKey: InjectionKey<ProductApi> = Symbol("product-api");
